import { Badge, Card, Image, Stack, Text } from "@mantine/core"
import { DesignStudioParametersToolkit } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { PublicResponses } from "@tfg/types/endpoints/public"
import {
  productCardBadgeBackgroundColorCSSVariable,
  productCardBadgeTextColorCSSVariable,
} from "@tfg/types/schemas/communication-studio/cssVariables"

import hanger from "~/assets/images/hanger.svg"
import shoe from "~/assets/images/shoe.svg"
import { useProductSheetUrl } from "~/pages/Public/hooks"

type Props = {
  product: PublicResponses.ProductCard
}

export const ProductCardJonak = ({ product }: Props) => {
  const { t } = useTranslation("public")
  const productSheetUrl = useProductSheetUrl(product.agecPopinUrl ?? "")

  return (
    <Card
      radius="md"
      withBorder
      component="a"
      href={productSheetUrl}
      target="_blank"
    >
      <Card.Section>
        <Image
          src={product.picture}
          alt={product.name}
          fit="fill"
          height={240}
          fallbackSrc={product.type.includes("FOOTWEAR") ? shoe : hanger}
        />
      </Card.Section>
      <Stack h={200} gap={4} mt="xs" justify="space-between">
        <Text
          // weight={600}
          style={{
            letterSpacing: "0.07em",
            fontFamily: "pragmatica",
          }}
        >
          {product.name}
        </Text>
        <Stack gap={4} align="flex-start" justify="flex-end">
          <Badge
            bg={DesignStudioParametersToolkit.getCssVariableLiteralName(
              productCardBadgeBackgroundColorCSSVariable
            )}
            c={DesignStudioParametersToolkit.getCssVariableLiteralName(
              productCardBadgeTextColorCSSVariable
            )}
            style={{
              letterSpacing: "0.07em",
              fontFamily: "pragmatica",
            }}
          >
            {product.collection}
          </Badge>
          <Stack gap={4} align="flex-start" justify="flex-end">
            <Text
              // weight={400}
              style={{
                fontFamily: "freight-text-italic",
                letterSpacing: "normal",
              }}
            >
              {t("productCard.reference")}
            </Text>
            <Text
              // fw={700}
              style={{
                letterSpacing: "0.07em",
                fontFamily: "pragmatica",
              }}
            >
              {product.brandReference}
            </Text>
          </Stack>
          <Stack gap={4} align="flex-start" justify="flex-end">
            <Text
              fw={400}
              style={{
                letterSpacing: "normal",
                fontFamily: "freight-text-italic",
              }}
            >
              {t("productCard.productType")}
            </Text>
            <Text
              // fw={700}
              style={{
                letterSpacing: "normal",
                fontFamily: "freight-text-regular",
              }}
            >
              {product.brandType}
            </Text>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  )
}
